module.exports = __webpack_public_path__ + "Assets/icons/features/team-permissions.svg";